/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import { EuiFieldSearch } from '@elastic/eui'

import genericMessages from '@modules/project-lib/genericMessages'
import { useQueryStringParams } from '@modules/utils/qs'

import { filterSchema } from './schema'

const OrganizationFilter: React.FunctionComponent = () => {
  const { setQueryStringItem, queryStringItems } = useQueryStringParams(filterSchema.parse)

  const { formatMessage } = useIntl()

  const value = queryStringItems.organization_id || ''

  return (
    <EuiFieldSearch
      style={{ width: '13rem' }}
      aria-label={formatMessage(genericMessages.orgId)}
      placeholder={formatMessage(genericMessages.orgId)}
      value={value}
      onChange={(e) => {
        const newValue = e.target.value

        setOrgId(newValue)
      }}
      onBlur={() => setOrgId(value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          setOrgId(value)
        }
      }}
    />
  )

  function setOrgId(s: string) {
    setQueryStringItem('organization_id', s || null)
  }
}

export default OrganizationFilter
